export enum TreeFilterLazyLoad {
  id = 'LAZYLOAD',
  label = 'Load more...',
  loading = 'Loading...',
}
